module.exports = __webpack_public_path__ + "static/media/flashcard.b18c9d2f.png";